/** Shared constants used across the coach workflow */

export const AGE_GROUPS = [
  { value: 'U7-U8',  label: 'U7-U8',  format: '5v5',  formatLabel: '5-a-side' },
  { value: 'U9-U10', label: 'U9-U10', format: '7v7',  formatLabel: '7-a-side' },
  { value: 'U11-U12',label: 'U11-U12',format: '9v9',  formatLabel: '9-a-side' },
  { value: 'U13-U14',label: 'U13-U14',format: '11v11',formatLabel: '11-a-side' },
  { value: 'U15-U16',label: 'U15-U16',format: '11v11',formatLabel: '11-a-side' },
  { value: 'U17-U18',label: 'U17-U18',format: '11v11',formatLabel: '11-a-side' },
  { value: 'U19+',   label: 'U19+',   format: '11v11',formatLabel: '11-a-side' },
] as const;

export const PROFICIENCY_LEVELS = ['Recreational', 'Competitive', 'Elite'] as const;

export const SEASON_PHASES = ['Pre-season', 'Early season', 'Mid-season', 'Late season', 'Playoffs'] as const;

/** Formations grouped by game format */
export const FORMATIONS_BY_FORMAT: Record<string, string[]> = {
  '5v5':  ['1-2-2', '2-1-2', '1-3-1'],
  '7v7':  ['2-3-1', '3-2-1', '2-1-2-1', '3-1-2'],
  '9v9':  ['3-3-2', '3-2-3', '2-4-2', '3-1-3-1'],
  '11v11': ['4-3-3', '4-4-2', '4-2-3-1', '3-5-2'],
};

export const FORMATIONS: Record<string, { label: string; positions: { role: string; x: number; y: number }[] }> = {
  // 5v5
  '1-2-2': {
    label: '1-2-2',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'L',  x: 0.25, y: 0.60 },
      { role: 'R',  x: 0.75, y: 0.60 },
      { role: 'LF', x: 0.30, y: 0.25 },
      { role: 'RF', x: 0.70, y: 0.25 },
    ],
  },
  '2-1-2': {
    label: '2-1-2',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.25, y: 0.70 },
      { role: 'RB', x: 0.75, y: 0.70 },
      { role: 'M',  x: 0.50, y: 0.45 },
      { role: 'LF', x: 0.30, y: 0.20 },
      { role: 'RF', x: 0.70, y: 0.20 },
    ],
  },
  '1-3-1': {
    label: '1-3-1',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'CB', x: 0.50, y: 0.70 },
      { role: 'LM', x: 0.20, y: 0.45 },
      { role: 'CM', x: 0.50, y: 0.45 },
      { role: 'RM', x: 0.80, y: 0.45 },
      { role: 'ST', x: 0.50, y: 0.18 },
    ],
  },
  // 7v7
  '2-3-1': {
    label: '2-3-1',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.25, y: 0.72 },
      { role: 'RB', x: 0.75, y: 0.72 },
      { role: 'LM', x: 0.20, y: 0.45 },
      { role: 'CM', x: 0.50, y: 0.45 },
      { role: 'RM', x: 0.80, y: 0.45 },
      { role: 'ST', x: 0.50, y: 0.18 },
    ],
  },
  '3-2-1': {
    label: '3-2-1',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.20, y: 0.72 },
      { role: 'CB', x: 0.50, y: 0.74 },
      { role: 'RB', x: 0.80, y: 0.72 },
      { role: 'LM', x: 0.30, y: 0.45 },
      { role: 'RM', x: 0.70, y: 0.45 },
      { role: 'ST', x: 0.50, y: 0.18 },
    ],
  },
  '2-1-2-1': {
    label: '2-1-2-1',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.25, y: 0.72 },
      { role: 'RB', x: 0.75, y: 0.72 },
      { role: 'CDM',x: 0.50, y: 0.55 },
      { role: 'LW', x: 0.25, y: 0.35 },
      { role: 'RW', x: 0.75, y: 0.35 },
      { role: 'ST', x: 0.50, y: 0.15 },
    ],
  },
  '3-1-2': {
    label: '3-1-2',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.20, y: 0.72 },
      { role: 'CB', x: 0.50, y: 0.74 },
      { role: 'RB', x: 0.80, y: 0.72 },
      { role: 'CM', x: 0.50, y: 0.45 },
      { role: 'LF', x: 0.35, y: 0.20 },
      { role: 'RF', x: 0.65, y: 0.20 },
    ],
  },
  // 9v9
  '3-3-2': {
    label: '3-3-2',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.20, y: 0.72 },
      { role: 'CB', x: 0.50, y: 0.74 },
      { role: 'RB', x: 0.80, y: 0.72 },
      { role: 'LM', x: 0.20, y: 0.48 },
      { role: 'CM', x: 0.50, y: 0.48 },
      { role: 'RM', x: 0.80, y: 0.48 },
      { role: 'LS', x: 0.35, y: 0.20 },
      { role: 'RS', x: 0.65, y: 0.20 },
    ],
  },
  '3-2-3': {
    label: '3-2-3',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.20, y: 0.72 },
      { role: 'CB', x: 0.50, y: 0.74 },
      { role: 'RB', x: 0.80, y: 0.72 },
      { role: 'LCM',x: 0.35, y: 0.50 },
      { role: 'RCM',x: 0.65, y: 0.50 },
      { role: 'LW', x: 0.15, y: 0.25 },
      { role: 'ST', x: 0.50, y: 0.20 },
      { role: 'RW', x: 0.85, y: 0.25 },
    ],
  },
  '2-4-2': {
    label: '2-4-2',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.30, y: 0.72 },
      { role: 'RB', x: 0.70, y: 0.72 },
      { role: 'LM', x: 0.15, y: 0.48 },
      { role: 'LCM',x: 0.38, y: 0.48 },
      { role: 'RCM',x: 0.62, y: 0.48 },
      { role: 'RM', x: 0.85, y: 0.48 },
      { role: 'LS', x: 0.35, y: 0.20 },
      { role: 'RS', x: 0.65, y: 0.20 },
    ],
  },
  '3-1-3-1': {
    label: '3-1-3-1',
    positions: [
      { role: 'GK', x: 0.50, y: 0.90 },
      { role: 'LB', x: 0.20, y: 0.72 },
      { role: 'CB', x: 0.50, y: 0.74 },
      { role: 'RB', x: 0.80, y: 0.72 },
      { role: 'CDM',x: 0.50, y: 0.55 },
      { role: 'LW', x: 0.20, y: 0.35 },
      { role: 'CAM',x: 0.50, y: 0.35 },
      { role: 'RW', x: 0.80, y: 0.35 },
      { role: 'ST', x: 0.50, y: 0.15 },
    ],
  },
  // 11v11
  '4-3-3': {
    label: '4-3-3',
    positions: [
      { role: 'GK',  x: 0.50, y: 0.92 },
      { role: 'LB',  x: 0.15, y: 0.72 },
      { role: 'CB',  x: 0.38, y: 0.76 },
      { role: 'CB',  x: 0.62, y: 0.76 },
      { role: 'RB',  x: 0.85, y: 0.72 },
      { role: 'CM',  x: 0.30, y: 0.52 },
      { role: 'CM',  x: 0.50, y: 0.48 },
      { role: 'CM',  x: 0.70, y: 0.52 },
      { role: 'LW',  x: 0.15, y: 0.25 },
      { role: 'ST',  x: 0.50, y: 0.18 },
      { role: 'RW',  x: 0.85, y: 0.25 },
    ],
  },
  '4-4-2': {
    label: '4-4-2',
    positions: [
      { role: 'GK',  x: 0.50, y: 0.92 },
      { role: 'LB',  x: 0.15, y: 0.72 },
      { role: 'CB',  x: 0.38, y: 0.76 },
      { role: 'CB',  x: 0.62, y: 0.76 },
      { role: 'RB',  x: 0.85, y: 0.72 },
      { role: 'LM',  x: 0.15, y: 0.48 },
      { role: 'CM',  x: 0.38, y: 0.50 },
      { role: 'CM',  x: 0.62, y: 0.50 },
      { role: 'RM',  x: 0.85, y: 0.48 },
      { role: 'ST',  x: 0.38, y: 0.20 },
      { role: 'ST',  x: 0.62, y: 0.20 },
    ],
  },
  '4-2-3-1': {
    label: '4-2-3-1',
    positions: [
      { role: 'GK',  x: 0.50, y: 0.92 },
      { role: 'LB',  x: 0.15, y: 0.72 },
      { role: 'CB',  x: 0.38, y: 0.76 },
      { role: 'CB',  x: 0.62, y: 0.76 },
      { role: 'RB',  x: 0.85, y: 0.72 },
      { role: 'CDM', x: 0.38, y: 0.56 },
      { role: 'CDM', x: 0.62, y: 0.56 },
      { role: 'LW',  x: 0.15, y: 0.35 },
      { role: 'CAM', x: 0.50, y: 0.35 },
      { role: 'RW',  x: 0.85, y: 0.35 },
      { role: 'ST',  x: 0.50, y: 0.15 },
    ],
  },
  '3-5-2': {
    label: '3-5-2',
    positions: [
      { role: 'GK',  x: 0.50, y: 0.92 },
      { role: 'CB',  x: 0.25, y: 0.76 },
      { role: 'CB',  x: 0.50, y: 0.78 },
      { role: 'CB',  x: 0.75, y: 0.76 },
      { role: 'LWB', x: 0.10, y: 0.52 },
      { role: 'CM',  x: 0.30, y: 0.52 },
      { role: 'CM',  x: 0.50, y: 0.48 },
      { role: 'CM',  x: 0.70, y: 0.52 },
      { role: 'RWB', x: 0.90, y: 0.52 },
      { role: 'ST',  x: 0.38, y: 0.20 },
      { role: 'ST',  x: 0.62, y: 0.20 },
    ],
  },
};

export const CORNER_COLORS: Record<string, string> = {
  'corner-technical': '#C0392B',
  'corner-physical': '#27AE60',
  'corner-psych': '#F39C12',
  'corner-social': '#2980B9',
  technical_tactical: '#C0392B',
  physical: '#27AE60',
  psychological: '#F39C12',
  social: '#2980B9',
};

export const CORNER_LABELS: Record<string, string> = {
  'corner-technical': 'Technical / Tactical',
  'corner-physical': 'Physical',
  'corner-psych': 'Psychological',
  'corner-social': 'Social',
  technical_tactical: 'Tech/Tact',
  physical: 'Physical',
  psychological: 'Psych',
  social: 'Social',
};

export const EQUIPMENT_OPTIONS = [
  'cones', 'balls', 'bibs', 'goals', 'poles', 'mannequins',
  'agility ladder', 'hurdles', 'ropes', 'nets',
] as const;
